// scroll window to top on link click
export function scrollToTop(selector) {
    var toTopLink = document.querySelectorAll(selector);
    if (toTopLink === null) return;

    toTopLink.forEach((e) =>
        e.addEventListener("click", function (event) {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        })
    );
}
